




import Vue from 'vue';
import { HumanizeTime } from 'mycorems-app-shared';

export default Vue.extend({
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  components: {
    'humanize-time': HumanizeTime,
  },
});
